import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/crm-expense-category';
const API_DETAIL = (id: number) => `/crm-expense-category/${id}`;

export interface ExpenseCategory {
  id: number;
  name?: string;
}

export const useExpenseCategories = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<ExpenseCategory[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    expenseCategories: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useExpenseCategory = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<ExpenseCategory>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    expenseCategory: data,
    isLoading,
    isError: error,
    mutate,
  };
};

